/* istanbul ignore file */

import { IMerchant } from "../..";

export const ALL_INTEGRATION_TYPES = [
    "CMP-PRODUCT",
    "E-CONOMIC",
    "FISKALY",
    "PARTNER-API",
    "VENUE-ACCESS",
    "VENUE-INVENTORY",
] as const;
export type typedIntegrationList = typeof ALL_INTEGRATION_TYPES;
export type IntegrationType = typedIntegrationList[number];

export const isIntegrationType = (value: string): value is IntegrationType =>
    ALL_INTEGRATION_TYPES.includes(value as IntegrationType);

export type IIntegration<Type extends IntegrationType = IntegrationType> = {
    id: string;
    merchantId: string;
    type?: Type;
    active: boolean;
    name: string;
    apiKey: string;
    createdAt: Date;
    deletedAt: Date | null;
    updatedAt: Date | null;
};

export type IIntegrationInput = Omit<
    IIntegration,
    "id" | "createdAt" | "deletedAt" | "updatedAt"
>;

export type IIntegrationApiKey = Pick<
    IIntegration,
    "apiKey" | "merchantId" | "type"
>;

export interface IntegrationSettings {
    id: string;
    type: IntegrationType;
}

export interface EconomicSettings extends IntegrationSettings {
    journalId: number;
    enableSyncByProductGroups: boolean;
    enableSyncAfterShiftClose: boolean;
    type: "E-CONOMIC";
}

export interface PartnerApiSettings extends IntegrationSettings {
    type: "PARTNER-API";
}

export interface VenueAccessSettings extends IntegrationSettings {
    type: "VENUE-ACCESS";
}

export interface CmpProductSettings extends IntegrationSettings {
    type: "CMP-PRODUCT";
    hostname: string;
    port: number;
    vhost: string;
    exchangeName: string;
    queueName: string;
    routingKey: string;
    username: string;
    password: string;
    cmpOrderUrl: string;
}

export interface FiskalySettings extends IntegrationSettings {
    type: "FISKALY";
    integrationId: IIntegration["id"];
    merchantId: IMerchant["id"];
    apiKey: string;
    apiSecret: string;
    organizationId: string | null;
    tssId: string | null;
    submissionNeeded: boolean;
}

export interface VenueInventorySettings extends IntegrationSettings {
    type: "VENUE-INVENTORY";
}

// Input types

export type IntegrationSettingsInput = Omit<IntegrationSettings, "id" | "type">;

export type EconomicSettingsInput = Omit<EconomicSettings, "id" | "type">;

export type CmpProductSettingsInput = Omit<CmpProductSettings, "id" | "type">;

export type FiskalySettingsDbInput = Omit<
    FiskalySettings,
    "id" | "type" | "integrationId" | "submissionNeeded"
>;

// The API secret field is not needed in the frontend, since it's set by the backend.
export type FiskalySettingsInput = Omit<FiskalySettingsDbInput, "apiSecret">;
